import { createContext } from "react";
import useAuth from "../hooks/useAuth";

const Context = createContext()

function UserProvider({ children }){
    
    const { authenticated, createUser, login, logout, user, setUser, changePassword } = useAuth()

    return(
        <Context.Provider value={{ authenticated, createUser, login, logout, user, setUser, changePassword }}>
            {children}
        </Context.Provider>
    )
}

export { Context, UserProvider }
